import { render } from "./LImageTitleBodyCard.vue?vue&type=template&id=ade836c4"
import script from "./LImageTitleBodyCard.vue?vue&type=script&lang=js"
export * from "./LImageTitleBodyCard.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__